import { FunctionComponent } from "react";
import styles from "./BulkActionDropdown.module.css";
import { MenuItem } from "@mui/material";
import { generateDynamicLinkForNotVerifiedUsers, rowsType } from "../../../../helper";


interface DropdownProps{
  handleCloseMenu: () => void
  setActiveOrInactive: (value: boolean) => void
  setDelete: (value: boolean) => void
  isUserActive: boolean | undefined
  isUserVerified: boolean | undefined,
  setSentMail: (value: boolean) => void,
  setUserToVerify: (value: any) => void,
  userDetails: rowsType | undefined
}

const ActionDropdown: FunctionComponent<DropdownProps> = ({isUserActive,isUserVerified,userDetails,handleCloseMenu,setDelete,setUserToVerify,setSentMail,setActiveOrInactive}) => {

  const modifyStatus = async (status: string) => {
    if(status === "Activate"){
      setActiveOrInactive(true)
    }else if(status === "Deactivate"){
      setActiveOrInactive(false);
    }else if(status === 'verification'){
      setSentMail(true);
      const shortLink = await generateDynamicLinkForNotVerifiedUsers(userDetails);
      setUserToVerify([{emailId: userDetails?.u_email_id,link: shortLink}]);
    }else{
      setDelete(true);
    }
    handleCloseMenu();
  }
  const handleShowActivate = () => {
    if((isUserActive === false) && (isUserVerified === true)){
      return true;
    }else if((isUserActive === false) && (isUserVerified === false)){
      return false;
    }
  }

  const handleShowDeactivate = () => {
    if((isUserActive === true) && (isUserVerified === true)){
      return true;
  }else if((isUserActive === false) && (isUserVerified === false)){
    return false;
  }
  }

  const handleShowVerification = () => {
    if((isUserActive === false) && (isUserVerified === false)){
      return true;
    }else {
      return false;
    }
  }
  const activeTicketCount = userDetails?.tickets_aggregate?.aggregate?.sum?.t_active_tickets;
  const soldTicketCount = userDetails?.tickets_aggregate?.aggregate?.sum?.t_sold_tickets;
  const handleShowDelete = () => {
    if((soldTicketCount && (soldTicketCount > 0))){
      return false;
    }else{
      return true;
    }
  }
  
  return (
    <div className={styles.bulkActionDropdown}>
      {handleShowActivate() && <MenuItem className={styles.menuItemActivateStyle} onClick={()=> modifyStatus("Activate")}>Activate</MenuItem>}
      {handleShowDeactivate() && <MenuItem className={styles.menuItemDeactivateStyle} onClick={()=> modifyStatus("Deactivate")}>Deactivate</MenuItem>}
      {handleShowVerification() && <MenuItem className={styles.menuItemVerificationStyle} onClick={()=> modifyStatus("verification")}>Send Verification</MenuItem>}
      {handleShowDelete() && <MenuItem className={styles.menuItemDeleteStyle} onClick={() => modifyStatus("Delete")}>Delete</MenuItem>}
    </div>
  );
};

export default ActionDropdown;
